import '../../../scss/components/cms/_cms-format-search.scss';
import { satGlobals } from '../../qaamgo/sat/helper/sat-globals';
import { testIsNonEmptyString, testIsString } from '../../lib/test-and-assert/test-base';

const $ = require('jquery');
global.$ = global.jQuery = $;

import(
    /* webpackMode: "eager" */
    '../qg-main'
).then(function () {
    $(function () {
        $(document).on('click', '.format-search-button', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $inputFrom = $('input[name="format-search-from"]');
            const $inputTo = $('input[name="format-search-to"]');

            let valueFrom = $inputFrom.val();
            let valueTo = $inputTo.val();

            if (!testIsString(valueFrom) || !testIsString(valueTo)) {
                return;
            }

            valueFrom = valueFrom.trim().toLowerCase();
            valueTo = valueTo.trim().toLowerCase();

            if (!testIsNonEmptyString(valueFrom)) {
                $inputFrom.focus();

                return;
            }

            if (!testIsNonEmptyString(valueTo)) {
                $inputTo.focus();

                return;
            }

            const paths = {
                en: `/supported-format/convert-${valueFrom}-to-${valueTo}`,
                es: `/es/formato-compatible/convert-${valueFrom}-to-${valueTo}`,
                fr: `/fr/format-supporte/convert-${valueFrom}-to-${valueTo}`,
                ru: `/ru/supported-format/convert-${valueFrom}-to-${valueTo}`,
                it: `/it/formati-supportati/convert-${valueFrom}-to-${valueTo}`,
                de: `/de/unterstuetztes-format/convert-${valueFrom}-to-${valueTo}`,
                id: `/id/format-didukung/convert-${valueFrom}-to-${valueTo}`,
                pt: `/pt/formato-suportado/convert-${valueFrom}-to-${valueTo}`,
                ar: `/ar/supported-format/convert-${valueFrom}-to-${valueTo}`,
                vi: `/vi/supported-format/convert-${valueFrom}-to-${valueTo}`,
            };

            const locale = satGlobals.getLocale();
            let path = paths.en;

            if (paths[locale]) {
                path = paths[locale];
            }

            const regexSubdomain = /^\w+\./;
            const host = window.location.hostname.replace(regexSubdomain, 'www.');

            window.location = `${window.location.protocol}//${host}${path}`;
        });
    });
});
